import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Notice } from '@app/_models/notice.model';
import { MessageResponse } from '@app/_models/responses';

@Injectable({ providedIn: 'root' })
export class NoticeService {
    constructor(private http: HttpClient) { }

    getPropertyNotices(propertyid: number) {
        return this.http.get<Notice[]>(`${environment.apiUrl}/api/notice/property/${propertyid}`);
    }

    getUnitNotices(propertyid: number, unitnumber: number) {
        return this.http.get<Notice[]>(`${environment.apiUrl}/api/notice/property/${propertyid}/unit/${unitnumber}`);
    }

    createNotice(notice: Notice) {
        return this.http.post<MessageResponse & { id?: number }>(`${environment.apiUrl}/api/notice`, notice);
    }

    updateNotice(id: number, notice: Notice) {
        return this.http.put<MessageResponse>(`${environment.apiUrl}/api/notice/${id}`, notice);
    }

    deleteNotice(id: number) {
        return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/notice/${id}`);
    }
}
